// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__3eYCV","MenuShow":"Menu_MenuShow__1wcCn Menu_Menu__3eYCV","navigation":"Menu_navigation__1fVcA"};